module.exports = __webpack_public_path__ + "img/badge-list-thumb-026.79af0bdb.png";